export default __webpack_public_path__ + "static/104-a9d72132281f1259b91d40f285406e40.jpg";